// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';

// const MisAuthContext = createContext(null);

// export const MisAuthProvider = ({ children }) => {
//   const [isMisUserAuthenticated, setIsMisUserAuthenticated] = useState(false);

//   const value = {
//     isMisUserAuthenticated,
//     setIsMisUserAuthenticated,
//   };

//   return (
//     <MisAuthContext.Provider value={value}>
//       {children}
//     </MisAuthContext.Provider>
//   );
// };

// export const useMisAuth = () => {
//   const context = useContext(MisAuthContext);
//   if (!context) {
//     throw new Error('useMisAuth must be used within a MisAuthProvider');
//   }
//   return context;
// };

// // Protected route component specifically for MIS user routes
// export const MisProtectedRoute = ({ children }) => {
//   const { isMisUserAuthenticated } = useMisAuth();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (!isMisUserAuthenticated) {
//       navigate('/mis-user-login');
//     }
//   }, [isMisUserAuthenticated, navigate]);

//   return isMisUserAuthenticated ? children : null;
// };

import useLocalStorage, { deleteFromStorage } from "@rehooks/local-storage";
import React, { createContext, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const MisAuthContext = createContext(null);

export const MisAuthProvider = ({ children }) => {
  const [state, setState] = useState({
    isMisUserAuthenticated: Boolean(localStorage.getItem("misUserEmail")),
    misUser: {
      email: localStorage.getItem("misUserEmail"),
      idpId: localStorage.getItem("misUserIdpId"),
      loginTime: localStorage.getItem("loginTime"),
    },
  });

  const navigate = useNavigate();
  const location = useLocation();

  const onMisLogin = (redirectUrl, userData) => {
    setState({
      isMisUserAuthenticated: true,
      misUser: userData,
    });
    const origin = location.state?.from?.pathname || redirectUrl;
    navigate(origin, { replace: true });
  };

  const onMisLogout = () => {
    // Clear MIS-specific storage items
    localStorage.removeItem("misUserEmail");
    localStorage.removeItem("misUserIdpId");
    localStorage.removeItem("loginTime");
    localStorage.removeItem("access_token");

    setState({
      isMisUserAuthenticated: false,
      misUser: null,
    });

    navigate("/mis-user-login", { replace: true });
  };

  const value = {
    onMisLogin: onMisLogin,
    onMisLogout: onMisLogout,
    ...state,
  };

  return (
    <MisAuthContext.Provider value={value}>{children}</MisAuthContext.Provider>
  );
};

export const useMisAuth = () => {
  const context = useContext(MisAuthContext);
  if (!context) {
    throw new Error("useMisAuth must be used within a MisAuthProvider");
  }
  return context;
};

// Protected route component for MIS user routes
export const MisProtectedRoute = ({ children }) => {
  const { isMisUserAuthenticated } = useMisAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!isMisUserAuthenticated) {
      navigate("/mis-user-login");
    }
  }, [isMisUserAuthenticated, navigate]);

  return isMisUserAuthenticated ? children : null;
};
